import api, { handleResponse, handleError } from './api';

/**
 * Lightweight client-side logger for brand conversion events.
 * The other two event types (gift_credited, gift_spent) are written server-side.
 */
const brandConversionService = {
  async logNotificationOpened(brandId, { partyPatronId = null, eventSponsorshipId = null } = {}) {
    return logEvent('notification_opened', { brandId, partyPatronId, eventSponsorshipId });
  },
  async logPromoClicked(brandId, { partyPatronId = null, eventSponsorshipId = null } = {}) {
    return logEvent('promo_clicked', { brandId, partyPatronId, eventSponsorshipId });
  },
};

async function logEvent(eventType, payload) {
  try {
    const response = await api.post('/brandconversions', { eventType, ...payload });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

export default brandConversionService;
